const locale = {
	HEADERMESSAGE: 'Herzlich Willkommen,',
	HEADERSUBMESSAGEUSER: 'melden Sie sich mit Ihrem Benutzer an.',
	HEADERSUBMESSAGECOMPANY: "geben Sie Ihr Firmenkürzel ein.",
	HEADERSUBMESSAGENFC: "melden Sie sich mit Ihrem NFC Tag an.",
	COMPANY: 'Firma',
	COMPANYCODE: 'Firmenkürzel',
	USERNAME: 'Benutzername',
	PASSWORD: 'Passwort',
	KEEPLOGIN: "Angemeldet bleiben",
	FORGOTPW: "Passwort vergessen?",
	SUBMITCOMPANY: "Weiter",
	SUBMITLOGIN: "Anmelden",
	COMPANYREQUIRED: "Bitte geben Sie Ihr Firmenkürzel ein",
	USERNAMEREQUIRED: "Bitte geben Sie Ihren Benutzernamen ein",
	PASSWORDREQUIRED: "Bitte geben Sie Ihr Passwort ein",
	INVALIDINPUT: "Ihre Eingabe enthält ungültige Zeichen",
	SHORTINPUT: "Ihre Eingabe ist zu kurz",
	NOCUSTOMERYET: "Noch kein ABS Kunde?",
	BECOMENEWCUSTOMER: "Jetzt anfragen",
	NOCOMPANYFOUND: "Es konnte keine Firma mit diesem Kürzel gefunden werden",
	YOUHAVELOGGEDOUT: "Sie haben sich abgemeldet",
	ALTERNATIVELOGIN: "Alternativ einloggen via",
	NFCLOGIN: "NFC Login",
	PASSWORDLOGIN: "Login mit Passwort",
	WAITINGFORTAG: "Es wird auf einen Chip zum Scannen gewartet...",
	STARTNEWSCAN: "Neuen Scan starten",
	NFCNOTAVAILABLE: "NFC ist nicht verfügbar",
	NFCNOTACTIVATED: "NFC ist nicht aktiviert",
	NFCNOTSUPPORTED: "NFC wird auf diesem Gerät nicht unterstützt",
	NONFCCHIPFOUND: "Kein NFC Chip gefunden",
	NFCCHIPNOTFORMATTED: "NFC Chip nicht formatiert",
	NFCCHIPNOTSUPPORTED: "NFC Chip nicht unterstützt",
	NFCHIPDETECTED: "NFC Chip erkannt, bitte warten",
	NFCCHIPUPDATENOTSUPPORTED: "NFC Chipupdate auf diesem Gerät nicht unterstützt",
	NFCHIPRESETSUCCESSFULL: "NFC Chip Reset erfolgreich",
	NFCHIPUPDATESUCCESSFULL: "NFC Chip Update erfolgreich",
	NFCDIFFERENTCHIPDETECTED: "Anderer NFC Chip erkannt, Vorgang abgebrochen",
	NFCERROR: "NFC Fehler, Vorgang abgebrochen",
	WAITINGONCHIPFORFORMAT: "Warte auf NFC Chip {{chipid}} zum Formattieren",
	WAITINGONCHIPFORUPDATE: "Warte auf NFC Chip {{chipid}} zum aktualisieren",
	OR: "Oder",
	NFCHIPINFO: "NFC Chip Info",
	DSGVO: "Datenschutz",
	AGB: "AGB",
	COPYRIGHT: "Copyright © Alpsware GmbH",
};

export default locale;
